const build = (...args) => {
    const arr = Array.from(args);
    return arr.join('/');
};

export {
    build
}

